import Cookies from "js-cookie";
import domify from "domify";
import { removeClass } from "../utilities";

export default function editContent(el, props) {
  const account = Cookies.get("admin-account");

  let editDataLinks = Array.prototype.slice.call(
    document.querySelectorAll("[data-content]")
  );

  const buttons = editDataLinks.map(link => {
    const data = JSON.parse(link.getAttribute("data-content"));
    return `
      <a
        class="edit-content__link"
        href="/admin/${data.type}/${data.id}/edit"
        data-history-ignore="true"
        target="_blank"
        rel="noopener">
        <span class="t-capitalize">${data.type.replace(/-/g, " ")}</span>: ${
      data.name
    }
      </a>
    `;
  });

  if (account && buttons.length > 0) {
    removeClass(el, "hide-from-all");
    el.appendChild(
      domify(`<div class="edit-content__inner">
        <span class="edit-content__button">Edit content</span>
        <div class="edit-content__buttons">
          ${buttons.join("")}
        </div>
      </div>`)
    );
  }
}
